import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Box, Typography } from '@mui/material'
import {
  BottomBar,
  PageContainer,
  SectionHeader,
  StyledTranslationOrText
} from '../../components'
import makeStyles from '@mui/styles/makeStyles'
import { useClientTheme } from '../../contexts'

const EMPTY_DEFAULT_MESSAGE = ' '
const REACT_APP_LOGIN_URL = process.env.REACT_APP_LOGIN_URL

const useStyles = makeStyles((theme) => ({
  loginPageImageDeskTop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexBasis: '60%',
      justifyContent: 'center',
      backgroundImage: `url(${theme.variables.loginImage})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: theme.variables.loginImageBackgroundSize
    }
  },
  loginPageImageMobile: {
    alignItems: 'center',
    display: 'flex',
    flexBasis: '60%',
    justifyContent: 'center',
    marginTop: '1rem',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  loginButton: {
    fontWeight: theme.variables.fontWeights.buttonFont,
    fontSize: theme.variables.fontSizes.logInTitle
  },
  loginPageBox: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row'
    }
  },
  loginPageContent: {
    alignItems: 'flex-start',
    display: 'flex',
    flexBasis: '40%',
    justifyContent: 'center',
    margin: '1rem 2rem 2rem 2rem',
    [theme.breakpoints.up('md')]: {
      margin: '4rem'
    }
  },
  whiteSpacePre: {
    whiteSpace: 'pre-line'
  }
}))

const LoginButtonLabel = () => {
  const classes = useStyles()
  return (
    <Typography className={classes.loginButton}>
      <FormattedMessage id="pages.loginPage.login" />
    </Typography>
  )
}

const LoginButtonDev = () => {
  const [user, setUser] = useState<string>('')
  return (
    <Box alignItems="center" display="flex" justifyContent="flex-start" pb={4}>
      <form action={'http://localhost:4000/auth'}>
        <input
          type="text"
          id="fname"
          name="fname"
          value={user}
          onChange={(e) => {
            setUser(e.currentTarget.value)
          }}
        ></input>
        <button type="submit">
          <LoginButtonLabel />
        </button>
      </form>
    </Box>
  )
}

const LoginButtonProd = () => {
  return (
    <Box alignItems="center" display="flex" justifyContent="flex-start" pb={4}>
      <a href={REACT_APP_LOGIN_URL}>
        <LoginButtonLabel />
      </a>
    </Box>
  )
}

const LoginButton = () => {
  return process.env.NODE_ENV === 'development' &&
    (undefined === process.env.REACT_APP_LOGIN_URL ||
      process.env.REACT_APP_LOGIN_URL.indexOf('.amazoncognito.') === -1) ? (
    <LoginButtonDev />
  ) : (
    <LoginButtonProd />
  )
}

export const LoginPage = () => {
  const theme = useClientTheme()

  const classes = useStyles()
  const { formatMessage } = useIntl()
  const altText = formatMessage({ id: 'logo' })

  return (
    <>
      <PageContainer>
        <Box flexGrow={1} flexShrink={1} className={classes.loginPageBox}>
          <Box
            className={classes.loginPageImageDeskTop}
            flexGrow={1}
            flexShrink={1}
          >
            <span role="img" aria-label={altText}></span>
          </Box>
          <Box
            className={classes.loginPageImageMobile}
            flexGrow={1}
            flexShrink={1}
          >
            <img
              src={theme.variables.loginImageMobile}
              alt={altText}
              title={altText}
            />
          </Box>
          <Box className={classes.loginPageContent} flexGrow={1} flexShrink={1}>
            <Box display="flex" flexDirection="column">
              <SectionHeader primaryTextId="pages.loginPage.title" />
              <Box className={classes.whiteSpacePre} pb={4}>
                <StyledTranslationOrText translationId="pages.loginPage.description" />
              </Box>
              <LoginButton />
              <StyledTranslationOrText
                text={EMPTY_DEFAULT_MESSAGE}
                translationId="pages.loginPage.additionalDescription"
              />
            </Box>
          </Box>
        </Box>
        <BottomBar showMobile />
      </PageContainer>
    </>
  )
}
